/*
 * Об ограничениях outClick:
 * Коллбэк на аут-клик вешается на самую верхнюю ноду документа (window)
 * Если еще где-то на странице прослушивается событие клика, то вначале отрабатывается нижний коллбек,
 * потом событие всплывает вверх, вызывая по очереди все коллбеки, которые встретит на своем пути.
 *
 * Из-за чего вероятен конфликт двух обработчиков событий (@click на одном элементе и v-out-click на другом)
 * Поэтому коллбек от @click следует вызывать через setTimeout(callback, 0)
 * setTimeout заставляет выполнять код через 0 секунд ПОСЛЕ всплытия события
 */
export default {
	bind(el, binding) {
		el.clickCallback = (e) => {
			const isClicked = el === e.target || el.contains(e.target);
			if (typeof binding.value === 'function' && !isClicked && el.offsetParent !== null) {
				binding.value();
			}
		};

		window.addEventListener('click', el.clickCallback);
	},
	unbind(el) {
		window.removeEventListener('click', el.clickCallback);
	},
};
